<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar></medsurf-navbar>
  <!-- Toolbar -->
  <medsurf-design-content-toolbar class="mb-2">
    <div class="p-toolbar-group-start">
      <button medsurf-design-input-button id="copyright_add"
        [label]="'global.copyright_add' | translate"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
      (click)="addNewCopyright()"></button>
    </div>
  </medsurf-design-content-toolbar>
  <!-- Content -->
  @if (constantAuthorFacade.copyrights$ | async; as copyrights) {
    <p-table
      [value]="copyrights"
      class="flex flex-1 overflow-hidden align-self-center w-11 lg:w-5 mb-2"
      styleClass="w-full"
      [rowTrackBy]="rowTrackBy"
      [scrollable]="true"
      scrollHeight="100%"
      selectionMode="single"
      (onRowSelect)="onRowSelect($event)"
      sortField="text">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="text">
            <span translate="global.text"></span> <p-sortIcon field="text"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-copyright>
        <tr [pSelectableRow]="copyright.id">
          <td>
            {{copyright.text}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
